//@ts-nocheck
import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Client } from '../models/client';
import { environment } from '../../../environments/environment';
import { PaginationResult } from '../models/pagination-result';
import { ImportResultDto } from '../models/importResultDto';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  discardChanges = signal<boolean>(false);

  API_URL = `${environment.apiUrl}/clients`;

  constructor(private http: HttpClient) { }

  getClients(filter: any = {}): Observable<PaginationResult<any[]>> {
    return this.http.get<PaginationResult<any[]>>(`${this.API_URL}/search-with-criteria`, { params: filter });
  }

  addClient(client: Client): Observable<Client> {
    return this.http.post<Client>(`${this.API_URL}`, client);
  }

  addClientWithManagementAssignment(client: ClientWithManagementAssignment): Observable<ClientWithManagementAssignment> {
    return this.http.post<ClientWithManagementAssignment>(`${this.API_URL}/client-with-management-assignment`, client);
  }

  updateClient(client: Client): Observable<Client> {
    return this.http.put<Client>(this.API_URL + `/${client.id}`, client);
  }

  archiveClient(id: number,): Observable<Client> {
    return this.http.delete<Client>(`${this.API_URL}/${id}`);
  }

  getAffectedRecords(params: any = {}): Observable<AffectedRecords> {
    return this.http.get<AffectedRecords>(`${this.API_URL}/affected-records`, { params });
  }
  getClientAffectedRecords(params: any = {}): Observable<AffectedRecords> {
    return this.http.get<AffectedRecords>(`${this.API_URL}/client-affected-records`, { params });
  }

  deleteClient(id: number, params: any = {}): Observable<Client> {
    return this.http.delete<Client>(`${this.API_URL}/${id}`, { params });
  }

  uploadDocument(file: File): Observable<ImportResultDto> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<ImportResultDto>(`${environment.apiUrl}/import-data/import-excel`, formData);
  }

  getSupervisorCategories(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiUrl}/clients/supervisor-categories`);
  }
}
